import { render, staticRenderFns } from "./SumOfAdministrative.vue?vue&type=template&id=8ddb1bf6&scoped=true&"
import script from "./SumOfAdministrative.vue?vue&type=script&lang=js&"
export * from "./SumOfAdministrative.vue?vue&type=script&lang=js&"
import style0 from "./SumOfAdministrative.vue?vue&type=style&index=0&id=8ddb1bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddb1bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
